const shopProducts = [
  // Lipsticks first
  {
    name: "Kay Hydra Cream Lipstick",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff897740dce193708fd052&add_resources=True&affiliate_id=Taniyapa-211079&product_id=16439255&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "MARS Matte Super Stay Lipstick - 03-SPIRIT",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a0029a7c045345432afcfef&add_resources=True&affiliate_id=Taniyapa-211079&product_id=10708406&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "FAE Beauty Lip Whip 12H Matte Liquid Lipstick - Screw",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a0029cfd079aecb8c9bd6ea&add_resources=True&affiliate_id=Taniyapa-211079&product_id=12447211&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Mamaearth Moisture Matte Longstay Mini Lipstick with Avocado Oil & Vitamin E - 01 Carnation Nude",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a002a56286ba41d952527d6&add_resources=True&affiliate_id=Taniyapa-211079&product_id=17031542&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "L'Oreal Paris Infallible Matte Resistance Liquid Lipstick - 635 Worth It Medium",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a002aa240dce193708fd10a&add_resources=True&affiliate_id=Taniyapa-211079&product_id=13168494&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Nykaa Matte to Last No Transfer Long Lasting Lipstick - Madras Kaapi (3.5g)",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a002ab7d079aecb8c9bd6ed&add_resources=True&affiliate_id=Taniyapa-211079&product_id=21317427&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },

  // Sunscreen next
  {
    name: "Dr. Sheth's Ceramide & Vitamin C Sunscreen SPF 50+ PA++++ In-Vivo Tested for Bright Skin",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=6a002a70a0c51dd825d71463&add_resources=True&affiliate_id=Taniyapa-211079&product_id=12341930&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Wishcare SPF50 Sunscreen Body Lotion",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff87b076588a43f9fb9160&add_resources=True&affiliate_id=Taniyapa-211079&product_id=7867857&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },

  // Other products after that
  {
    name: "Plum 2% Niacinamide Moisturiser",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff848e82e8380dde5e3083&add_resources=True&affiliate_id=Taniyapa-211079&product_id=10489448&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Plum 15% Vitamin C Serum",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff8776a13d6488e7c09f44&add_resources=True&affiliate_id=Taniyapa-211079&product_id=1425356&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Joy Ubtan Tan Removal Face Wash",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff879540dce193708fd04a&add_resources=True&affiliate_id=Taniyapa-211079&product_id=20300243&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
  {
    name: "Bare Anatomy Anti Dandruff Shampoo",
    iframeSrc:
      "https://affiliate.nykaa.com/v2/get_product_widget?ad_id=69ff88eef797472e389ad6e2&add_resources=True&affiliate_id=Taniyapa-211079&product_id=19651747&store=nykaa&text_color=000000&theme_variation=TEXT_AND_IMAGE&theme=affiliate&aff_link_type=affiliate%3Anap_dashboard%3Aproduct",
  },
];

export default shopProducts;